<template>
  <div class="detail-page-metrics-preview" data-test-id="detail-page-metrics-live-preview">
    <div class="detail-page-metrics-preview__intro">
      <Typography variant="h-5">Live Preview</Typography>
      <Typography variant="body-2">
        Showing the left column only. The full page preview will be available later.
      </Typography>
    </div>
    <Alert
      variant="warning"
      message="String values may be missing if aggregate metrics are selected"
    />
    <ProgramDetailColumn
      :image-url="imageUrl"
      :date-range-label="dateRangeLabel"
      :metric-rows="previewRows"
      :basis="payoutCadence === 'IMMEDIATE' ? 'PAID' : 'PROJECTED'"
      :is-dollar-budget="isDollarBudget"
    />
  </div>
</template>

<script>
import moment from "moment";
import Typography from "@/components/generic/Typography.vue";
import ProgramDetailColumn from "@/components/participant/programs/ProgramDetailColumn.vue";
import { toPreviewRows } from "./metricPreview";
import Alert from "@/components/generic/Alert.vue";
export default {
  name: "DetailPageMetricsStepPreview",
  components: { Typography, ProgramDetailColumn, Alert },
  props: {
    startDate: { type: String, default: null },
    endDate: { type: String, default: null },
    imageUrl: { type: String, default: null },
    // Configured ProgramMetricRows, straight off the step.
    rows: { type: Array, default: () => [] },
    metricProjection: { type: Object, default: null },
    payoutCadence: { type: String, default: null },
    isDollarBudget: { type: Boolean, default: false },
  },
  computed: {
    previewRows() {
      return toPreviewRows(this.rows, this.metricProjection);
    },
    dateRangeLabel() {
      const fmt = (d) => (d ? moment(d).format("MMM D, YYYY") : "TBD");
      return `${fmt(this.startDate)} \u2013 ${fmt(this.endDate)}`;
    },
  },
};
</script>

<style scoped>
.detail-page-metrics-preview {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  text-align: left;
}

.detail-page-metrics-preview__intro {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
</style>
